import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["EnFilterButtonBase"], {
        modelValue: $setup.menuIsVisible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($setup.menuIsVisible) = $event)),
        id: $setup.returnFilterButtonId($props.id),
        "apply-button-text": $setup.applyButtonTextComputed,
        "reset-button-text": $setup.resetButtonTextComputed,
        "apply-filters": $setup.applyFilters,
        "on-reset-button-clicked": $setup.onResetButtonClicked,
        "display-string": $setup.displayString,
        label: $props.label,
        "reset-filter": $setup.resetFilter
    }, {
        label: _withCtx(() => [
            _createCommentVNode(" The filter button's label "),
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        prefix: _withCtx(() => [
            _createVNode($setup["EnFilterButtonTypePrefix"], {
                "should-show-prefix": $setup.shouldShowPrefixComputed,
                type: $setup.type
            }, null, 8 /* PROPS */, ["should-show-prefix", "type"])
        ]),
        default: _withCtx(() => [
            _createVNode($setup["EnTextField"], {
                ref: "input",
                modelValue: $setup.changedValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.changedValue) = $event)),
                modelModifiers: { trim: true },
                hint: $props.hint,
                id: $setup.returnId($props.id),
                type: "number",
                onKeydown: _withKeys($setup.applyFilters, ["enter"]),
                "persistent-hint": "",
                autofocus: ""
            }, null, 8 /* PROPS */, ["modelValue", "hint", "id"]),
            ($props.filterTypeSelectionVisible)
                ? (_openBlock(), _createBlock($setup["EnFilterTypeSelectButton"], {
                    key: 0,
                    modelValue: $setup.selectedType,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.selectedType) = $event)),
                    id: $setup.returnTypeId($props.id),
                    items: $setup.typeItemsNumber
                }, null, 8 /* PROPS */, ["modelValue", "id", "items"]))
                : _createCommentVNode("v-if", true)
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["modelValue", "id", "apply-button-text", "reset-button-text", "display-string", "label"]));
}
